// extracted by mini-css-extract-plugin
export var button = "_ns-0";